import styled from '@emotion/styled';

export const CardNoticeContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	background-color: #fff;
	border-radius: ${(props) => props.theme.effects.radiusLg};
	border: 1px solid ${(props) => props.theme.colors.gray100};
	box-shadow: ${(props) => props.theme.effects.shadowMd};
	flex: 1;
	height: 100%;
	min-height: 38rem;
	overflow: hidden;
	@media screen and (max-width: 900px) {
		min-height: 32rem;
	}
`;
